import { defineStore } from 'pinia';
import HomeApiService from '@/services/api/HomeApiService';

const loadedFontUrls = new Set();
const DEFAULT_FONT = 'Montserrat';

function isDefaultFont(font) {
  return font?.nombre?.toLowerCase() === DEFAULT_FONT.toLowerCase();
}

function fontsFromTypography(typography) {
  if (!typography) {
    return [];
  }
  return [typography.titleTypography, typography.textTypography].filter(font => font && !isDefaultFont(font));
}

export const useFontStore = defineStore('fontStore', {
  state: () => ({
    fonts: [],
  }),
  getters: {
    getFont: state => id => state.fonts.find(font => font.id === id),
  },
  actions: {
    loadFontChoices(fontsToLoad) {
      if (!fontsToLoad?.length) {
        return;
      }

      const urls = new Set();
      fontsToLoad.forEach(font => {
        let url = font?.url;
        if (!url && font?.id != null) {
          url = this.fonts.find(f => f.id === font.id)?.url;
        }
        if (url) {
          urls.add(url);
        }
      });

      urls.forEach(url => {
        if (!url || loadedFontUrls.has(url)) {
          return;
        }
        loadedFontUrls.add(url);
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = url;
        document.head.appendChild(link);
      });
    },
    loadLandingFonts(typography) {
      this.loadFontChoices(fontsFromTypography(typography));
    },
    async loadAgencyFonts() {
      try {
        this.fonts = (await HomeApiService.getFuentes()) ?? [];
        this.loadFontChoices(this.fonts);
      } catch (error) {
        this.fonts = [];
        console.error(error);
      }
    },
  },
});
